import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { ControlContainer, FormGroup } from '@angular/forms';
import { setMaxDatePicker } from '@utils/functions/datepicker';

@Component({
  selector: 'ba-pep-partners-list-form',
  templateUrl: './pep-partners-list-form.component.html',
  styleUrls: ['./pep-partners-list-form.component.scss']
})
export class PepPartnersListFormComponent implements OnInit {

  @Output() newPepPartnerRequest = new EventEmitter<void>();

  ibkConfig = setMaxDatePicker(1);

  constructor(
    private readonly controlContainer: ControlContainer
  ) { }

  ngOnInit(): void {
    this.ibkConfig = setMaxDatePicker(0);
  }

  get pepPartnerList() {
    return this.controlContainer.control as FormGroup;
  }
}